import { post, get, put } from '../../../methods'
import apiUrl from '../../../Url/ApiUrl'
import DataTypeModel from '../../../../models/DataType'
import { AxiosResponse } from 'axios'

export const getTempoProjects = (parameters: Record<string, any>, cancelToken): Promise<AxiosResponse<any[]>> =>
    post(apiUrl.projects.tempoProjectsList, DataTypeModel(parameters), cancelToken)

export const getTempoQuestions = (parameters: Record<string, any>): Promise<AxiosResponse<Record<string, any>>> =>
    get(apiUrl.projects.tempoQuestions, DataTypeModel({}, parameters))

export const registerProjectFeedbackAnswers = (
    data: Record<string, any>,
): Promise<AxiosResponse<Record<string, any>>> =>
    post(apiUrl.projects.tempoAnswers, DataTypeModel(data.bodyRequest, data.uriParams))

export const getTempoProject = (
    uriParams: { projectId: string },
    cancelToken,
): Promise<AxiosResponse<Record<string, any>>> =>
    get(apiUrl.projects.tempoProject, DataTypeModel({}, uriParams), cancelToken)

export const patchTempoProject = (bodyRequest, uriParams: { projectId: string }): Promise<AxiosResponse<any[]>> =>
    put(apiUrl.projects.patchTempoProject, DataTypeModel(bodyRequest, uriParams))
